import zappy from "@zappy-ride/library.react.components";
import { FormHiddenCalculation } from "./FormHiddenCalculation";

export * from "./FormHiddenCalculation";

zappy.FactoryInstance.registerComponent(FormHiddenCalculation);
